import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../components/ui/card';
import { BarChart3, PackageSearch, FileText, Truck, Receipt, ArrowRight } from 'lucide-react';

const REPORTS = [
    {
        id: 'sales',
        path: '/reports/sales',
        icon: BarChart3,
        accent: 'text-[#2A9D8F]',
        bg: 'bg-[#2A9D8F]/10',
        testId: 'report-card-sales',
    },
    {
        id: 'inventory',
        path: '/reports/inventory',
        icon: PackageSearch,
        accent: 'text-[#264653]',
        bg: 'bg-[#264653]/10',
        testId: 'report-card-inventory',
    },
    {
        id: 'customer_statement',
        path: '/reports/customer-statement',
        icon: FileText,
        accent: 'text-[#C08478]',
        bg: 'bg-[#C08478]/10',
        testId: 'report-card-customer-statement',
    },
    {
        id: 'purchase',
        path: '/reports/purchase',
        icon: Truck,
        accent: 'text-[#E9C46A]',
        bg: 'bg-[#E9C46A]/15',
        testId: 'report-card-purchase',
    },
    {
        id: 'vat',
        path: '/reports/vat',
        icon: Receipt,
        accent: 'text-[#E76F51]',
        bg: 'bg-[#E76F51]/10',
        testId: 'report-card-vat',
    },
];

const ReportsHub = () => {
    const { t } = useTranslation(['entities', 'common']);
    return (
        <div data-testid="reports-hub" className="space-y-8 animate-fadeIn">
            <div>
                <p className="text-[11px] uppercase tracking-[2px] text-[#C08478] font-semibold mb-2">
                    {t('entities:reports.section_label')}
                </p>
                <h1 className="text-3xl font-bold text-[#1A1A1A] tracking-tight">{t('entities:reports.hub.title')}</h1>
                <p className="text-gray-500 mt-1">{t('entities:reports.hub.subtitle')}</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {REPORTS.map((r) => {
                    const Icon = r.icon;
                    return (
                        <Link to={r.path} key={r.id} data-testid={r.testId} className="group">
                            <Card className="border-0 shadow-sm hover:shadow-md transition cursor-pointer h-full">
                                <CardContent className="p-5 space-y-3">
                                    <div className="flex items-start justify-between">
                                        <div className={`w-11 h-11 rounded-lg ${r.bg} flex items-center justify-center`}>
                                            <Icon size={22} className={r.accent} />
                                        </div>
                                        <ArrowRight size={18} className="text-gray-300 group-hover:text-[#C08478] group-hover:translate-x-1 transition" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-[#1A1A1A]">{t(`entities:reports.hub.cards.${r.id}.title`)}</h3>
                                        <p className="text-xs text-gray-500 mt-1">{t(`entities:reports.hub.cards.${r.id}.description`)}</p>
                                    </div>
                                </CardContent>
                            </Card>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default ReportsHub;
